import script from "./Tags.vue?vue&type=script&setup=true&lang=js"
export * from "./Tags.vue?vue&type=script&setup=true&lang=js"

import "./Tags.vue?vue&type=style&index=0&id=3cf95b89&lang=scss&scoped=true"

import exportComponent from "/tmp/tesla_data/tmp/apply_3091/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cf95b89"]])

export default __exports__